// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-wrapper[data-v-68d6c0ce]{left:50%;position:fixed;transform:translateX(-50%);z-index:50}.fade-enter-active[data-v-68d6c0ce],.fade-leave-active[data-v-68d6c0ce]{transition:opacity .3s}.fade-enter[data-v-68d6c0ce],.fade-leave-to[data-v-68d6c0ce]{opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
